module.exports = __webpack_public_path__ + "static/img/A2E_Bangladesh_Mobiya_2017SSD.d5bf2cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_Bangladesh_Mobiya_2017SSD.jpg
// module id = KJAT
// module chunks = 0